// extracted by mini-css-extract-plugin
export var container = "EditDetails-module--container--vTdMp";
export var content = "EditDetails-module--content--UAp8r";
export var footer = "EditDetails-module--footer--VGCgW";
export var input = "EditDetails-module--input--D7jKX";
export var title = "EditDetails-module--title--dfT8k";